module.exports = __webpack_public_path__ + "static/media/F.38a40be6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/F.svg
// module id = 409
// module chunks = 0